/**
 * Skleja klasy CSS, pomijając wartości fałszywe.
 * Pozwala pisać cn('base', isActive && 'active', props.className) zamiast
 * ręcznych szablonów z zagnieżdżonymi trójargumentowymi warunkami.
 */
export const cn = (...parts) => parts.flat(Infinity).filter(Boolean).join(' ');

export default cn;
